// extracted by mini-css-extract-plugin
module.exports = {"button":"button-m__button__1XNJB"};